import React from "react";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment/moment";
import {setEditCard} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import TextArea from "../../../common/TextArea";
import {cardTypeOptions, checkPermissionStartingTree} from "../../../../_helpers/commonFunctions";
import BetterCheckBox from "../../../common/BetterCheckBox";

const CardsEdit = () => {
    const dispatch = useDispatch();
    const editCard = useSelector((state) => state.CASH_DATA.editCard);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "db") {
            if (moment(e).isValid()) prepChange[name] = moment(e).toDate();
            else prepChange[name] = "";
        } else if (type === "ab") {
            let val = e.target.value;
            if (isNaN(+val) || +val <= 0) val = 0;
            else val = +Number(val).toFixed(2);
            prepChange[name] = val;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "cb-active") {
            prepChange[name] = e.target.checked ? "active" : "inActive";
        }
        dispatch(setEditCard({...editCard, ...prepChange}));
    }

    return (
        <div>
            <Row className={"mb-3"}>
                <Col md={3}>
                    <Dropdown
                        name={"type"}
                        label={"Τύπος Κάρτας"}
                        key={Math.random()}
                        autoComplete={"off"}
                        required={true}
                        options={cardTypeOptions}
                        defaultValue={cardTypeOptions.find((el) => el.value === editCard.type)}
                        disabled={true}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"name"}
                        label={"Ονομασία κάρτας"}
                        value={editCard.name}
                        required={true}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"numbering"}
                        label={"Αριθμός Κάρτας"}
                        autoComplete={"off"}
                        value={editCard.numbering}
                        required={true}
                        disabled={true}
                    />
                </Col>
                <Col md={2} className={"d-flex justify-content-end"}>
                    <div style={{marginTop: "28px"}}>
                        <BetterCheckBox
                            name={"isActive"}
                            text={"Ενεργή"}
                            checked={editCard.isActive === "active"}
                            onChange={(e) => handleOnChange(e, "cb-active", "isActive")}
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Σημειώσεις"}
                        rows={4}
                        value={editCard.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>
            {checkPermissionStartingTree("accounting", permissionsData) && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-3"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Λογιστικού Λογαριασμού"}
                                value={editCard.accounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "accounting")}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={editCard.bypassAccounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export const CardsEditLog = () => {

}

export default CardsEdit;
